import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'

class CartProgress extends React.Component {
  constructor(props) {
    super(props)
    const { disableAuth, stepsBeforeAuth } = props

    this.steps = [null]

    if (Array.isArray(stepsBeforeAuth)) {
      for (const step of stepsBeforeAuth) {
        this.steps.push(step.key)
      }
    }
    if (!disableAuth) {
      this.steps.push('auth')
    }
    this.steps = this.steps.concat(['infos', 'end'])
  }

  render() {
    const { step, backLinkText, backLinkFunction } = this.props

    const stepsItems = this.steps.map((key, i) => {
      const isActive = step === key
      const translationId = `app.cart.step.${key}.title`

      if (i === 0) {
        return null
      }

      return (
        <li
          key={i}
          className={classNames('reservation-progress__bar__step', { 'is-active': isActive })}
        >
          <FormattedMessage id={translationId} />
        </li>
      )
    })

    return (
      <div className="reservation-progress">
        <a href="" onClick={backLinkFunction} className="reservation-progress__back">
          <i className="icon--arrow-left"></i>
          <FormattedMessage id={backLinkText} />
        </a>
        <div className="reservation-progress__container">
          <ul className="reservation-progress__bar">
            { stepsItems }
          </ul>
        </div>
      </div>
    )
  }
}

CartProgress.propTypes = {
  step: PropTypes.string.isRequired,
  backLinkText: PropTypes.string.isRequired,
  backLinkFunction: PropTypes.func.isRequired,
  disableAuth: PropTypes.bool,
  stepsBeforeAuth: PropTypes.array,
}

CartProgress.contextTypes = {
  router: PropTypes.object.isRequired,
}

export default CartProgress
